import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
// The parent element below captures clicks that bubble from nested buttons and
// links, so we can close the navbar when the user clicks on a link or button
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import NavModal from 'components/nav/shared/NavModal';
import useIsTitleOrSectionHovered from 'hooks/useIsTitleOrSectionHovered';
import useIsPDP from 'hooks/useIsPDP';
import isEventWithinLinkOrButton from 'commons/isEventWithinLinkOrButton';
import CartModal from 'components/nav/shared/CartModal';
import BrowserOnly from 'components/consumer/BrowserOnly';
import DesktopPrimaryNav from './components/DesktopPrimaryNav';
import DesktopNavCategoryModal from './components/DesktopNavCategoryModal';
const DesktopHeader = () => {
  const $ = _c(28);
  const {
    resetIsTitleOrSectionHovered,
    selectedItem,
    setIsTitleHovered,
    setIsSectionHovered
  } = useIsTitleOrSectionHovered();
  const showStaticHeader = useIsPDP();
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] !== selectedItem) {
    t0 = () => {
      setIsOpen(!!selectedItem);
    };
    t1 = [selectedItem];
    $[0] = selectedItem;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const t2 = !showStaticHeader;
  let t3;
  if ($[3] !== showStaticHeader || $[4] !== t2) {
    t3 = classNames("bg-white z-[1002] max-[1023px]:hidden top-0", {
      sticky: t2,
      relative: showStaticHeader
    });
    $[3] = showStaticHeader;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== resetIsTitleOrSectionHovered) {
    t4 = event => {
      if (isEventWithinLinkOrButton(event)) {
        resetIsTitleOrSectionHovered();
      }
    };
    $[6] = resetIsTitleOrSectionHovered;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== selectedItem || $[9] !== setIsTitleHovered) {
    t5 = <DesktopPrimaryNav selectedCategoryId={selectedItem} setIsLinkHovered={setIsTitleHovered} />;
    $[8] = selectedItem;
    $[9] = setIsTitleHovered;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = !!selectedItem;
  let t7;
  if ($[11] !== selectedItem || $[12] !== setIsSectionHovered || $[13] !== t6) {
    t7 = <BrowserOnly><DesktopNavCategoryModal categoryId={selectedItem} setIsSectionHovered={setIsSectionHovered} isOpen={t6} /></BrowserOnly>;
    $[11] = selectedItem;
    $[12] = setIsSectionHovered;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="min-h-[55px]">{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t8) {
    t9 = <div className={t3} onClick={t4}>{t8}</div>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== isOpen || $[23] !== t9) {
    t10 = <NavModal isOpen={isOpen}>{t9}</NavModal>;
    $[22] = isOpen;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CartModal />;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10) {
    t12 = <>{t10}{t11}</>;
    $[26] = t10;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default DesktopHeader;